import React, { useEffect, useState } from "react";
import { AddressPopupLabels, AddressPopupPropTypes } from "./types";
import { default as AddressPopupLayout } from "./layout";
import { usePickupAreas, useQueryPostcodes } from "../../Api/storeApi";
import useGoogleMapsApi from "../../Helpers/hooks/useGoogleMapsApi";
import useDebounceState from "../../Helpers/hooks/useDebounceState";
import useBodyScrollLock from "../../Helpers/hooks/useBodyScrollLock";
import GoogleTagUtil from "~/assets/js/Helpers/google-tag-util";
import CreateGroupOrder from "../CreateGroupOrder";
import useTriggerAddressPopupListener from "../../Helpers/hooks/useTriggerAddressPopupListener";

export const TABS = {
    SINGLE_ORDER: "SINGLE_ORDER",
    GROUP_ORDER: "GROUP_ORDER",
};

const AddressPopup = ({
    setOpen,
    submitData,
    forceSelection,
    forceOnGroupOrder,
    openTab,
}) => {
    const [locationQuery, setLocationQuery] = useState({
        zip: "",
        location: "",
    });
    const [tab, setTab] = useState(TABS.SINGLE_ORDER);
    const [startGroupOrder, setStartGroupOrder] = useState(false);
    const [noHouseNumberError, setNoHouseNumberError] = useState(false);
    const deboucedLocationQuery = useDebounceState(locationQuery.location);
    const [deliveryOptions, setDeliveryOptions] = useState([]);
    const [forcePickup, setForcePickup] = useState(false);
    const [address, setAddress] = useState(null);
    const { pickupAreas } = usePickupAreas();
    const { postcodeLocation } = useQueryPostcodes(locationQuery.zip);
    const forceSelectionOnKonfigurator = new RegExp(
        "^/(meine-bowl|mein-potti)/$"
    ).test(window.location.pathname);

    const {
        fetchSuggestedLocations,
        selectAddressSuggestion,
        checkPlaceDetails,
    } = useGoogleMapsApi({
        config: reactConfig,
        setForcePickup,
        setAddress,
        setSuggestions: setDeliveryOptions,
        setHouseNumberError: setNoHouseNumberError,
    });

    useEffect(() => {
        if (!locationQuery.location?.length) {
            setDeliveryOptions([]);
            return;
        }

        fetchSuggestedLocations(deboucedLocationQuery, postcodeLocation);
    }, [deboucedLocationQuery, postcodeLocation]);

    useEffect(() => {
        if (address === null) {
            return;
        }

        GoogleTagUtil.trackPostcodePopup("complete", {
            storeId: address?.area.store_id,
            page: window.location.pathname,
            postcode: address?.address?.postcode,
            street: !!address?.address?.address,
            deliveryType: address?.area.type,
        });

        const shouldCloseOverlay = tab === TABS.SINGLE_ORDER;

        submitData(
            address?.area,
            address?.location,
            address?.address,
            shouldCloseOverlay
        );

        setStartGroupOrder(!shouldCloseOverlay);
    }, [address]);

    useEffect(() => {
        GoogleTagUtil.trackPostcodePopup("open", {
            page: window.location.pathname,
        });
    }, []);

    useBodyScrollLock(true);

    const onAddressSelect = async ({ selectedAddress, isDelivery }) => {
        if (isDelivery) {
            selectAddressSuggestion(selectedAddress.id);
        } else {
            setAddress({
                area: selectedAddress,
            });
        }
    };

    useTriggerAddressPopupListener(() => {
        setStartGroupOrder(false);
        setOpen(true);
    });

    if (startGroupOrder) {
        return (
            <CreateGroupOrder
                onBackClick={() => {
                    setStartGroupOrder(false);
                    setOpen(false);
                }}
            />
        );
    }

    return (
        <div id="address-overlay-box" onClick={(evt) => evt.stopPropagation()}>
            <AddressPopupLayout
                {...{
                    setOpen,
                    forceOnGroupOrder,
                    suggestions: deliveryOptions,
                    setLocationQuery,
                    pickupAreas,
                    forcePickup,
                    setForcePickup,
                    onAddressSelect,
                    checkPlaceDetails,
                    noHouseNumberError,
                    openTab,
                    forceSelection:
                        forceSelectionOnKonfigurator || forceSelection,
                    startGroupOrder: () => setStartGroupOrder(true),
                    tab,
                    setTab,
                }}
            />
        </div>
    );
};

AddressPopup.propTypes = AddressPopupPropTypes;
AddressPopup.defaultProps = {
    labels: AddressPopupLabels,
};
export default AddressPopup;
